// Czech marketing/SEO copy — single source of truth for on-page content.
// Differentiated per appliance for topical depth and AI extractability.
export const content = {
  home: {
    metaTitle: 'Oprava praček, myček a sušiček Praha | Dokonalá Oprava',
    metaDescription:
      'Oprava praček, myček a sušiček u vás doma v Praze. Výjezd zdarma, cena předem a záruka na práci. Zavolejte +420 730 520 302.',
    faq: [
      {
        q: 'Kolik stojí oprava pračky, myčky nebo sušičky v Praze?',
        a: 'Běžná oprava vyjde na 800 až 2000 Kč podle typu závady. Výjezd technika po Praze je zdarma a diagnostika od 500 Kč je při provedené opravě zcela zdarma. Přesnou cenu vám sdělíme předem, ještě před zahájením práce, takže vás nečekají žádné skryté poplatky.',
      },
      {
        q: 'Jak si domluvím termín návštěvy technika?',
        a: 'Zavolejte nebo napište přes WhatsApp na číslo +420 730 520 302. Podle typu spotřebiče, závady a vaší adresy společně domluvíme konkrétní dostupný termín. Objednávky přijímáme každý den od 7:00 do 22:00.',
      },
      {
        q: 'Jaké značky spotřebičů opravujete?',
        a: 'Opravujeme prakticky všechny běžné značky, například Bosch, Siemens, Samsung, LG, Whirlpool, Electrolux, Beko, Miele, Candy, Gorenje, Indesit, AEG, Zanussi, Mora, Amica a Hisense. Servisujeme jak starší modely, tak novější spotřebiče s elektronikou.',
      },
      {
        q: 'V jaké oblasti Prahy působíte?',
        a: 'Působíme v celé Praze a blízkém okolí, od Prahy 1 až po Prahu 10 i okrajové čtvrti. Naše sídlo je ve Strašnicích na Praze 10, běžně jezdíme do Vinohrad, na Žižkov, do Karlína, na Smíchov, do Dejvic, Vršovic, Nuslí, Holešovic i Libně. Výjezd po Praze je vždy zdarma.',
      },
      {
        q: 'Poskytujete na opravu záruku?',
        a: 'Ano, na každou provedenou práci i vyměněné díly poskytujeme záruku. Používáme kvalitní náhradní díly a máme více než šest let zkušeností, takže si za odvedenou opravou stojíme.',
      },
      {
        q: 'Jak mohu za opravu zaplatit?',
        a: 'Zaplatit můžete hotově nebo bezhotovostně přímo na místě po dokončení opravy. Cenu vám sdělíme předem, takže přesně víte, kolik zaplatíte, a nečekají vás žádné skryté poplatky.',
      },
      {
        q: 'Je diagnostika závady zdarma?',
        a: 'Diagnostika od 500 Kč je zcela zdarma, pokud u nás objednáte opravu spotřebiče. Technik závadu zjistí přímo u vás doma a rovnou vám navrhne řešení i konečnou cenu. Platíte tedy jen za samotnou opravu.',
      },
    ],
  },
  brands: [
    'Bosch', 'Siemens', 'Samsung', 'LG', 'Whirlpool', 'Electrolux', 'Beko', 'Miele',
    'Candy', 'Gorenje', 'Indesit', 'AEG', 'Zanussi', 'Mora', 'Amica', 'Hisense',
  ],
  districts: [
    'Praha 1', 'Praha 2', 'Praha 3', 'Praha 4', 'Praha 5', 'Praha 6', 'Praha 7',
    'Praha 8', 'Praha 9', 'Praha 10', 'Strašnice', 'Vinohrady', 'Žižkov', 'Karlín',
    'Smíchov', 'Dejvice', 'Vršovice', 'Nusle', 'Holešovice', 'Libeň', 'Braník',
    'Podolí', 'Michle', 'Malešice', 'Vysočany',
  ],
  trustBlock: {
    heading: 'Proč si nás zákazníci vybírají',
    note: 'Recenze od reálných zákazníků najdete v našem profilu na Googlu, hodnocení si nikdy nevymýšlíme.',
    points: [
      {
        title: 'Termín domluvíme přímo s vámi',
        description:
          'Při objednání si potvrdíme typ závady, adresu i konkrétní dostupný termín. Objednávky přijímáme denně od 7:00 do 22:00.',
      },
      {
        title: 'Férové a jasné ceny',
        description:
          'Výjezd po Praze zdarma, diagnostika zdarma při opravě a přesná cena sdělená předem. Žádné skryté poplatky, běžná oprava vyjde na 800 až 2000 Kč.',
      },
      {
        title: 'Více než 6 let zkušeností',
        description:
          'Za sebou máme přes šest let praxe s opravami praček, myček a sušiček všech běžných značek, od starších modelů po spotřebiče s moderní elektronikou.',
      },
      {
        title: 'Záruka na odvedenou práci',
        description:
          'Na každou opravu i vyměněné díly poskytujeme záruku. Používáme kvalitní náhradní díly, takže se na opravený spotřebič můžete spolehnout.',
      },
    ],
  },
  services: {
    washing: {
      slug: '/oprava-pracek-praha',
      navLabel: 'Pračky',
      shortName: 'Oprava praček Praha',
      metaTitle: 'Oprava praček Praha u vás doma | Dokonalá Oprava',
      metaDescription:
        'Oprava praček všech značek u vás doma v Praze. Výjezd zdarma, cena předem a záruka na práci. Volejte +420 730 520 302.',
      h1: 'Oprava praček v Praze přímo u vás doma',
      lead: 'Neodčerpává vaše pračka vodu, netočí bubnem nebo hlásí chybový kód? Závadu zjistíme a opravu provedeme přímo u vás doma.',
      intro:
        'Opravujeme automatické pračky všech běžných značek přímo u zákazníka doma v Praze a okolí. Výjezd technika po Praze je zdarma a přesnou cenu opravy vám vždy sdělíme předem. Se závadami praček máme více než šest let zkušeností, takže většinu poruch zvládneme vyřešit hned na místě.',
      body: 'Pračka je spotřebič, který používáme prakticky denně, a její porucha dokáže domácnost výrazně omezit. Naši technici jezdí přímo za vámi do bytu či domu po celé Praze a poruchu diagnostikují na místě. Diagnostika od 500 Kč je zdarma, pokud u nás objednáte opravu. Nejčastěji řešíme pračky, které neodčerpávají vodu kvůli ucpanému čerpadlu nebo filtru, netočí bubnem kvůli opotřebovaným uhlíkům motoru nebo prasklému řemenu, případně neohřívají vodu kvůli vadnému topnému tělesu. Časté jsou také poruchy ložisek bubnu, které se projevují silným hlukem a vibracemi při ždímání, nebo zaseknutá dvířka, u kterých selhal zámek. U moderních praček bývá příčinou závady také elektronika a chybové kódy na displeji, které umíme přečíst a správně vyhodnotit. Při opravě používáme kvalitní náhradní díly, ať už jde o čerpadla, topná tělesa, ložiska, řemeny nebo elektronické moduly. Běžná oprava pračky vyjde na 800 až 2000 Kč podle typu závady a náročnosti výměny dílu, přesnou částku vám ale řekneme dřív, než začneme pracovat. Nečekají vás tedy žádné skryté poplatky a rozhodnutí, zda opravu provést, je vždy na vás. Na provedenou práci i vyměněné díly poskytujeme záruku. Opravujeme pračky značek Bosch, Siemens, Samsung, LG, Whirlpool, Electrolux, Beko, Miele, AEG, Candy, Gorenje, Indesit a dalších. Konkrétní dostupný termín návštěvy si domluvíte telefonicky nebo přes WhatsApp na čísle +420 730 520 302.',
      commonFaults: [
        'Pračka neodčerpává vodu (ucpané čerpadlo nebo filtr)',
        'Buben se netočí (opotřebené uhlíky, prasklý řemen)',
        'Pračka neohřívá vodu (vadné topné těleso)',
        'Nejdou otevřít dvířka (zaseknutý zámek dvířek)',
        'Silný hluk a vibrace při ždímání (opotřebená ložiska)',
        'Z pračky teče voda (vadné těsnění, prasklá hadice)',
        'Pračka se nezapne nebo vypadává (elektronika, napájení)',
        'Na displeji svítí chybový kód',
      ],
      faq: [
        {
          q: 'Kolik stojí oprava pračky v Praze?',
          a: 'Běžná oprava pračky vyjde na 800 až 2000 Kč podle typu závady. Výjezd po Praze je zdarma a diagnostika od 500 Kč je při provedené opravě zdarma. Přesnou cenu vám sdělíme předem, žádné skryté poplatky.',
        },
        {
          q: 'Proč pračka neodčerpává vodu?',
          a: 'Nejčastější příčinou je ucpané vypouštěcí čerpadlo nebo zanesený filtr, kam se dostanou drobné předměty a vlákna. Někdy jde o zalomenou vypouštěcí hadici nebo vadné čerpadlo. Závadu zjistíme na místě a obvykle ji vyřešíme hned.',
        },
        {
          q: 'Vyplatí se opravit starší pračku?',
          a: 'Ve většině případů ano, zejména u kvalitnějších značek jako Miele, Bosch nebo Siemens. Po diagnostice vám řekneme přesnou cenu opravy, abyste se mohli rozhodnout. Pokud by oprava nedávala smysl, upřímně vám to řekneme.',
        },
        {
          q: 'Přijedete opravit pračku i o víkendu?',
          a: 'V sobotu pracujeme od 7:00 do 16:00, takže i o víkendu se k vám dostaneme. Objednávky přijímáme každý den od 7:00 do 22:00 na čísle +420 730 520 302 nebo přes WhatsApp.',
        },
      ],
    },
    dishwasher: {
      slug: '/oprava-mycek-praha',
      navLabel: 'Myčky',
      shortName: 'Oprava myček Praha',
      metaTitle: 'Oprava myček nádobí Praha u vás doma | Dokonalá Oprava',
      metaDescription:
        'Oprava myček nádobí všech značek u vás doma v Praze. Výjezd zdarma, cena předem a záruka na práci. Volejte +420 730 520 302.',
      h1: 'Oprava myček nádobí v Praze přímo u vás doma',
      lead: 'Myčka nemyje dočista, nenapouští vodu nebo netěsní? Závadu zjistíme a opravu provedeme přímo u vás doma.',
      intro:
        'Opravujeme myčky nádobí všech běžných značek přímo u zákazníka doma v Praze a okolí. Výjezd technika po Praze je zdarma a konečnou cenu opravy vám sdělíme předem. Díky více než šesti letům zkušeností většinu závad myček vyřešíme přímo na místě.',
      body: 'Myčka nádobí nám šetří čas každý den, a když přestane fungovat, hromadí se špinavé nádobí velmi rychle. Naši technici přijedou přímo za vámi domů po celé Praze a poruchu diagnostikují na místě. Diagnostika od 500 Kč je zdarma, pokud u nás následně objednáte opravu. U myček nejčastěji řešíme situace, kdy spotřebič nenapouští nebo neodčerpává vodu kvůli vadnému napouštěcímu ventilu, ucpanému filtru či čerpadlu. Časté je také to, že myčka nemyje dočista, což bývá způsobeno ucpanými ostřikovacími rameny, zaneseným filtrem nebo vadným cirkulačním čerpadlem. Řešíme rovněž myčky, které nehřejí vodu, takže nádobí zůstává mastné a nedosuší se, nebo naopak myčky, které netěsní a teče z nich voda kvůli vadnému těsnění dvířek či prasklé hadici. U spotřebičů s elektronikou se setkáváme s chybovými kódy na displeji a poruchami řídicí jednotky, které umíme přečíst a vyhodnotit. Poměrně běžná je také porucha Aquastop ventilu na přívodní hadici. Při opravě používáme kvalitní náhradní díly, ať už jde o čerpadla, ventily, topná tělesa, ostřikovací ramena nebo elektronické moduly. Běžná oprava myčky vyjde na 800 až 2000 Kč podle typu závady, přesnou částku vám ale řekneme ještě před zahájením práce. Nečekají vás tak žádné skryté poplatky a rozhodnutí o opravě necháváme vždy na vás. Na provedenou práci i vyměněné díly poskytujeme záruku. Opravujeme myčky značek Bosch, Siemens, Samsung, LG, Whirlpool, Electrolux, Beko, Miele, AEG, Candy, Gorenje, Indesit a dalších. Konkrétní dostupný termín si domluvíte telefonicky nebo přes WhatsApp na čísle +420 730 520 302.',
      commonFaults: [
        'Myčka nenapouští vodu (vadný napouštěcí ventil)',
        'Myčka neodčerpává vodu (ucpaný filtr nebo čerpadlo)',
        'Nádobí zůstává špinavé (ucpaná ostřikovací ramena)',
        'Myčka nehřeje vodu (vadné topné těleso)',
        'Nádobí se nedosuší (porucha ohřevu, ventilace)',
        'Z myčky teče voda (netěsnící dvířka, prasklá hadice)',
        'Zablokovaný Aquastop na přívodní hadici',
        'Na displeji svítí chybový kód',
      ],
      faq: [
        {
          q: 'Kolik stojí oprava myčky nádobí v Praze?',
          a: 'Běžná oprava myčky vyjde na 800 až 2000 Kč podle typu závady. Výjezd po Praze je zdarma a diagnostika od 500 Kč je při provedené opravě zdarma. Konečnou cenu vám sdělíme předem, žádné skryté poplatky.',
        },
        {
          q: 'Proč myčka nemyje nádobí dočista?',
          a: 'Nejčastěji za to mohou ucpaná ostřikovací ramena, zanesený filtr nebo vadné cirkulační čerpadlo, které nedokáže vytvořit dostatečný tlak vody. Roli hraje i nefunkční ohřev vody. Příčinu zjistíme na místě a obvykle ji vyřešíme hned.',
        },
        {
          q: 'Proč myčka nenapouští nebo neodčerpává vodu?',
          a: 'Když myčka nenapouští vodu, bývá příčinou vadný napouštěcí ventil nebo zablokovaný Aquastop. Když neodčerpává, jde obvykle o ucpaný filtr, čerpadlo nebo vypouštěcí hadici. Obě závady umíme diagnostikovat přímo u vás doma.',
        },
        {
          q: 'Přijedete opravit myčku i o víkendu?',
          a: 'V sobotu jsme k dispozici od 7:00 do 16:00. Objednávky přijímáme každý den od 7:00 do 22:00 na čísle +420 730 520 302 nebo přes WhatsApp. Při objednání společně potvrdíme konkrétní dostupný termín.',
        },
      ],
    },
    dryer: {
      slug: '/oprava-susicek-praha',
      navLabel: 'Sušičky',
      shortName: 'Oprava sušiček Praha',
      metaTitle: 'Oprava sušiček prádla Praha u vás doma | Dokonalá Oprava',
      metaDescription:
        'Oprava sušiček prádla všech typů u vás doma v Praze. Kondenzační i s tepelným čerpadlem. Výjezd zdarma. Volejte +420 730 520 302.',
      h1: 'Oprava sušiček prádla v Praze přímo u vás doma',
      lead: 'Sušička nesuší, nehřeje nebo hlásí zaplněnou nádržku? Závadu zjistíme a opravu provedeme přímo u vás doma.',
      intro:
        'Opravujeme sušičky prádla všech typů, kondenzační i s tepelným čerpadlem, přímo u zákazníka doma v Praze a okolí. Výjezd technika po Praze je zdarma a přesnou cenu opravy vám vždy sdělíme předem. S poruchami sušiček máme více než šest let zkušeností.',
      body: 'Sušička prádla je pohodlný pomocník, zvlášť v bytě bez místa na sušák, a její porucha dokáže pořádně zkomplikovat domácnost. Naši technici přijedou přímo za vámi domů po celé Praze a závadu diagnostikují na místě. Diagnostika od 500 Kč je zdarma, pokud u nás objednáte opravu. U sušiček nejčastěji řešíme situace, kdy spotřebič nehřeje a prádlo zůstává vlhké, což u kondenzačních modelů bývá způsobeno vadným topným tělesem, zatímco u modelů s tepelným čerpadlem jde obvykle o poruchu kompresoru nebo únik chladiva. Velmi častou závadou je také ucpaný kondenzátor a zanesené filtry, kvůli kterým sušička hlásí, že je potřeba vyčistit výměník, nebo přestává sušit. Řešíme rovněž sušičky, které chybně hlásí plnou nádržku na vodu, přestože je prázdná, což způsobuje ucpané čerpadlo kondenzátu nebo vadný senzor hladiny. Setkáváme se i s netočícím se bubnem kvůli prasklému hnacímu řemenu, s hlučným chodem způsobeným opotřebenými ložisky nebo kladkami a s poruchami vlhkostních senzorů, které špatně vyhodnocují stav prádla. U elektroniky čteme chybové kódy na displeji a řešíme vadné řídicí jednotky. Při opravě používáme kvalitní náhradní díly, ať už jde o topná tělesa, čerpadla kondenzátu, řemeny, ložiska, senzory nebo elektronické moduly. Běžná oprava sušičky vyjde na 800 až 2000 Kč podle typu závady, přesnou částku vám ale řekneme předem. Nečekají vás žádné skryté poplatky a na provedenou práci i vyměněné díly poskytujeme záruku. Opravujeme sušičky značek Bosch, Siemens, Samsung, LG, Whirlpool, Electrolux, Beko, Miele, AEG, Candy, Gorenje a dalších. Konkrétní dostupný termín si domluvíte telefonicky nebo přes WhatsApp na čísle +420 730 520 302.',
      commonFaults: [
        'Sušička nehřeje a prádlo zůstává vlhké (vadné topné těleso)',
        'Porucha tepelného čerpadla (kompresor, únik chladiva)',
        'Ucpaný kondenzátor a zanesené filtry',
        'Chybné hlášení plné nádržky na vodu (čerpadlo, senzor)',
        'Buben se netočí (prasklý hnací řemen)',
        'Hlučný chod (opotřebená ložiska, kladky)',
        'Sušička špatně vyhodnocuje vlhkost prádla (vadný senzor)',
        'Na displeji svítí chybový kód',
      ],
      faq: [
        {
          q: 'Kolik stojí oprava sušičky prádla v Praze?',
          a: 'Běžná oprava sušičky vyjde na 800 až 2000 Kč podle typu závady. Výjezd po Praze je zdarma a diagnostika od 500 Kč je při provedené opravě zdarma. Přesnou cenu vám sdělíme předem, žádné skryté poplatky.',
        },
        {
          q: 'Opravujete i sušičky s tepelným čerpadlem?',
          a: 'Ano, opravujeme kondenzační sušičky i modely s tepelným čerpadlem. U sušiček s tepelným čerpadlem nejčastěji řešíme poruchy kompresoru, ucpaný výměník nebo zanesené filtry. Typ vaší sušičky nám můžete říct už při objednání.',
        },
        {
          q: 'Proč sušička nesuší, i když se točí?',
          a: 'Nejčastější příčinou je vadný ohřev, tedy topné těleso u kondenzačních modelů nebo tepelné čerpadlo u novějších sušiček. Roli hraje i ucpaný kondenzátor, zanesené filtry nebo vadný vlhkostní senzor. Přesnou příčinu zjistíme přímo u vás doma.',
        },
        {
          q: 'Proč sušička hlásí plnou nádržku, i když je prázdná?',
          a: 'Obvykle za to může ucpané čerpadlo kondenzátu, které nedokáže vodu přečerpat do nádržky, nebo vadný senzor hladiny. Někdy stačí vyčistit odtokové cesty. Závadu diagnostikujeme na místě a obvykle ji vyřešíme hned.',
        },
      ],
    },
  },
};

export const serviceList = [
  content.services.washing,
  content.services.dishwasher,
  content.services.dryer,
];

export const serviceBySlug = Object.fromEntries(serviceList.map((s) => [s.slug, s]));
